
export const compressImage = (file: File, quality = 0.7, maxWidth = 1920, maxHeight = 1080, format: "image/jpeg" | "image/webp" = "image/jpeg"): Promise<string> => {
  //*Creamos una promesa porque es un proceso asíncrono
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        //* Crea un lienzo <canvas> solo en memoria, no se dibuja en la pantalla, para luego redibujar la imagen con menos calidad y/o resolución
        const canvas = document.createElement("canvas");
        let { width, height } = img;

        //* Escalar si es más grande que el máximo, se calcula un ratio para reducirla de forma proporcional
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width *= ratio;
          height *= ratio;
        }
        //* Ajustamo el tamaño
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        //* Dibujamo en el canva
        ctx?.drawImage(img, 0, 0, width, height);

        //* Exportar comprimida
        //* Convertimos el canvas a una imagen en base64 con con el formato y la calidad especificados
        const compressedDataUrl = canvas.toDataURL(format, quality);
        res(compressedDataUrl.split(",")[1]);
      };
      img.onerror = rej;
    };
    reader.onerror = rej;
  });
};

export const isHeic = (file: File) => {
  return (
    file.type === "image/heic" ||
    file.type === "image/heif" ||
    /\.(heic|heif)$/i.test(file.name)
  );
};

export const convertHeicToJpeg = async (file: File): Promise<File> => {
  const { default: heic2any } = await import("heic2any");

  const result = await heic2any({
    blob: file,
    toType: "image/jpeg",
    quality: 0.9,
  });

  const blob = Array.isArray(result) ? result[0] : result;

  return new File([blob], file.name.replace(/\.(heic|heif)$/i, ".jpg"), {
    type: "image/jpeg",
    lastModified: Date.now(),
  });
};
